module.exports = __webpack_public_path__ + "static/media/undraw_breakfast_psiw.036328e2.svg";